export default {
  CREATE: `Créer un type d'horaire`,
  DELETE_BUTTON: {
    TITLE: `Supprimer le type d'horaire`,
    SUMMARY: `Etes-vous certain de vouloir supprimer ce type d'horaire ?`,
    PRIMARY_ACTION: `Supprimer le type d'horaire`
  },
  LIST: {
    TITLE: `Liste des types d'horaire`
  },
  END_TIME: `Fin`,
  START_TIME: `Début`,
  TEAMS: `Équipes`,
  SEARCH_RANGE: `Filtre avancé`,
  START_TIME_RANGE: `Borne de début`,
  END_TIME_RANGE: `Borne de fin`,
  CSV_EXPORT_NAME: `export_types_dhoraire_{{date}}`,
  form: {
    CREATE: {
      TITLE: `Création d'un type de quart`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Modification d'un type de quart`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Nom du type de quart`,
      DESCRIPTION: `Ce nom devrait vous permettre de facilement le repérer.`,
      PLACEHOLDER: `Entrez un nom pour le type de quart`
    },
    STARTTIME: {
      LABEL: `Heure de début`,
      DESCRIPTION: `L'heure doit être en format 24h.`,
      PLACEHOLDER: `Entrez une heure de début pour le type de quart`
    },
    ENDTIME: {
      LABEL: `Heure de fin`,
      DESCRIPTION: `L'heure doit être en format 24h.`,
      PLACEHOLDER: `Entrez une heure de fin pour le type de quart`
    },
    SEARCHRANGE: {
      LABEL: `Utiliser comme filtre avancé pour l'horaire`,
      DESCRIPTION: `Permet d’enregistrer des bornes de début et de fin pour un filtrage avancé des quarts de travail. Ce filtre permettra d’afficher tous les quarts qui débutent dans l’intervalle fournie.`
    },
    STARTRANGESTARTTIME: {
      LABEL: `Ouverture de la borne de l'heure de début`,
      DESCRIPTION: `L'heure doit être en format 24h.`
    },
    STARTRANGEENDTIME: {
      LABEL: `Fermeture de la borne de l'heure de début`,
      DESCRIPTION: `L'heure doit être en format 24h.`
    },
    DEPARTMENTS: {
      LABEL: `Département`,
      DESCRIPTION: `Départements du type d'horaire`
    },
    NAME_REQUIRED: `Le nom du type de quart est obligatoire.`,
    HOUR_REQUIRED: `Les heures de début et de fin sont requises`
  }
}
